module.exports = __webpack_public_path__ + "img/nzrelay.ed737653.png";